module.exports = __webpack_public_path__ + "img/trunk_1x2_z16.1d46dab0.svg";